import { useCallback } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useDispatch } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';

import Dialog from 'app/components/MaterialDialog';
import Version from 'components/atoms/Version';
import PAGES from 'constants/pages';
import dialog from 'features/common/dialog';
import { dialogs } from 'features/views/roboAdvisory/roboAdvisoryHandover/constants';

import RAHandoverModalBody from './RAHandoverModalBody';

const RAHandOverModal = NiceModal.create(() => {
	const modal = useModal();
	const dispatch = useDispatch();

	const onExit = useCallback(() => {
		dispatch(dialog.actions.close(dialogs.NO_SUBORDINATE_TO_HANDOVER));
	}, [dispatch]);

	return (
		<Dialog
			modal={modal}
			title={getMessage('roboAdvisory:handOverModalTitle')}
			content={<RAHandoverModalBody />}
			onExit={onExit}
			maxWidth="lg"
			version={
				<Version
					screenId={PAGES.roboAdvisory.roboAdvisoryHandoverModal.id}
					screenName={PAGES.roboAdvisory.roboAdvisoryHandoverModal.name}
				/>
			}
		/>
	);
});

export default RAHandOverModal;
